export default __webpack_public_path__ + "f25734d25a8fc219347f275a16321acb.png";